<template>
  <div>
    <vs-popup :title="$t('CreateNewRole')" :active.sync="showModal">
      <form>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="model.name"
              name="roleName"
              :label="$t('RoleName')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('roleName')">{{
              errors.first("roleName")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="model.englishName"
              name="roleEnglishName"
              :label="$t('EnglishName')"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('roleEnglishName')"
              >{{ errors.first("roleEnglishName") }}</span
            >
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-checkbox class="float-left" v-model="isActive" disabled>{{
              $t("Active")
            }}</vs-checkbox>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              type="filled"
              class="float-right mb-4"
              @click.prevent="submitForm"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    roleName: {
      required: "لطفا عنوان نقش را وارد نمایید.",
    },
    roleEnglishName: {
      required: "لطفا نام انگلیسی را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "usermanagement-Roles-Create",
  props: {
    show: { default: false },
  },
  data() {
    return {
      isActive: true,
      model: {},
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createRole: "role/create",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createRole(this.model).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.$emit("finish");
            this.model = {};
            this.$validator.reset();
          });
        }
      });
    },
  },
};
</script>
